import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    ItemDescription: { label: i18n.t('invoices.invoices_issuing.descripcion'), value: '' },
    UnitOfMeasure: { label: i18n.t('products.UnitOfMeasure'), value: '' },
    ArticleCode: { label: i18n.t('invoices.invoices_issuing.cod_producto'), value: '' },
    UnitPriceWithoutTaxMin: { label: i18n.t('invoices.invoices_issuing.step4.precio_unitario_min'), value: '', type: 'number' },
    UnitPriceWithoutTaxMax: { label: i18n.t('invoices.invoices_issuing.step4.precio_unitario_max'), value: '', type: 'number' },
  } 
}
const getTranslateColumns = () => [
  { field: 'idProducto', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
  { field: 'ArticleCode', title: i18n.t('invoices.invoices_issuing.cod_producto'), hidden: true, columnMenu: 'myTemplate', width: '210px', locked: false },
  { field: 'ItemDescription', title: i18n.t('invoices.invoices_issuing.descripcion'), columnMenu: 'myTemplate', width: '660px', locked: false },
  { field: 'UnitOfMeasure', title: i18n.t('products.UnitOfMeasure_short'), format: 'TIPOS_UNIDADES_MEDIDA', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '200px', locked: false, sortable: false, groupable: false },
  { field: 'UnitPriceWithoutTax', title: i18n.t('invoices.invoices_issuing.precio_unitario'), format: 'currency_8', cell: 'numberTemplate', columnMenu: 'myTemplate', width: '160px', locked: false },
] 
const getDefaultForm = () => ({ 
  products: []
})
const customState = { form: getDefaultForm() }
const customGetters = {
  form: state => state.form
}
const customActions = {
  resetForm ({ state }) {
    state.form = getDefaultForm()
  }
}
const mystore = parent({ customState, customGetters, customActions, navigate: false, namespaced: true, selectable: true, expandable: 'manual', getTranslateColumns, getTranslateMasterFilters })

export default mystore
